import { createClient } from '@supabase/supabase-js'

// Variables de entorno con fallback
const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL || 'https://tu-proyecto.supabase.co'
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || 'tu_anon_key_aqui'

// Verificar si Supabase está configurado correctamente
export const isSupabaseConfigured = () => {
  return supabaseUrl !== 'https://tu-proyecto.supabase.co' && 
         supabaseAnonKey !== 'tu_anon_key_aqui'
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Función para obtener el estado de configuración
export const getSupabaseStatus = () => {
  return {
    configured: isSupabaseConfigured(),
    url: supabaseUrl,
    hasAnonKey: supabaseAnonKey !== 'tu_anon_key_aqui'
  }
}

export default supabase

